module.exports = __webpack_public_path__ + "static/media/add-stop.834aabc0.svg";